<template>
  <svg xmlns:svg="http://www.w3.org/2000/svg" style="z-index: 2" xmlns="http://www.w3.org/2000/svg" version="1.1"
    width="100%" height="100%" preserveAspectRatio="none" id="state_interpreter">
    <title>Инидикатор состояния</title>
    <rect x="0" y="0" width="100%" height="100%" stroke="gray" stroke-width="1"
      :fill="type === 1 ? fill : state_text.fill" class="interpreter"></rect>
    <text id="heading_caption" :y="getY()" :x="getX()" fill="black" :text-anchor="text_anchor" :font-weight="fontStyle"
      :class="{ unselectable: $store.getters.editMode }" :style="style">
      <template v-if="type === 1">
        <template v-if="typeof state_text === 'string'">{{ state_text }}</template>
        <template v-else-if="state_text?.length">
          {{ state_text[0] }}
          <tspan v-for="index in state_text.length - 1" :x="getX()" dy="1.2em" :key="index">
            {{ state_text[index] }}
          </tspan>
        </template>
        <title>{{ state_text }}</title>
      </template>
      <template v-else>{{ state_text.name }}</template>
    </text>
  </svg>
</template>

<script>
import MixinBase from "./mixin-base.js";

export default {
  name: "state_interpreter",
  mixins: [MixinBase],
  props: {
    heading_caption: {
      default: "*****",
    },
    text_anchor: {
      type: String,
      default: "start",
    },
    type: { type: [Number, String], default: 1 },
    options: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      style: {},
    };
  },
  methods: {
    invertColor(hex) {
      //TODO не используется?
      if (hex.indexOf("#") === 0) {
        hex = hex.slice(1);
      }
      // Convert hex to RGB values
      var r = parseInt(hex.substring(0, 2), 16);
      var g = parseInt(hex.substring(2, 4), 16);
      var b = parseInt(hex.substring(4, 6), 16);
      // Invert the RGB values
      r = 255 - r;
      g = 255 - g;
      b = 255 - b;
      // Convert the inverted RGB values back to hex
      var invertedHex = "#" + r.toString(16) + g.toString(16) + b.toString(16);
      return invertedHex;
    },
    //TODO: будет запрашивать при каждом обновление возможно это излишне
    getX() {
      switch (this.text_anchor) {
        case "end":
          return "98%";
        case "middle":
          return "50%";
        default:
          return "2%";
      }
    },
    getY() {
      if (this.height < 44) return "70%";
      const val = this.height / 22;
      return 68 / val + "%";
    },
  },
  mounted() {
    this.style = {
      "font-size": (localStorage.scale ? localStorage.scale : 13) - 1 + "px",
    };
  },
  computed: {
    fill: function () {
      let fill = "#FFFFFF";
      let hex =
        this.properties[this.PropertyURI]?.outputValueColor?.toString(16) ||
        this.events[this.event]?.outputValueColor?.toString(16);
      if (hex) {
        hex = "#" + hex;
        if (hex.length > 1 && hex.length < 7) {
          const count = 7 - hex.length;
          for (let i = 0; i < count; i++) {
            hex = hex + "0";
          }
        }
        if (hex.length === 7)
          hex = hex[0] + hex[5] + hex[6] + hex[3] + hex[4] + hex[1] + hex[2];
        fill = hex;
      }
      return fill;
    },
    state_text: function () {
      if (this.type === 1) {
        if (
          typeof this.properties[this.PropertyURI] == "undefined" &&
          typeof this.events[this.event] == "undefined"
        ) {
          return this.heading_caption;
        } else {
          if (this.properties[this.PropertyURI]) {
            return this.properties[this.PropertyURI].outputValueText;
          }

          if (this.events[this.event]) {
            return this.events[this.event].outputValueText;
          }
        }
      } else if (this.type === 2) {
        //TODO: Работа через справочник где ид будет браться из свойства
        let value = null;
        if (typeof this.properties[this.PropertyURI] == "undefined") {
          value = null;
        } else {
          value = this.properties[this.PropertyURI].outputValue.value;
        }
        const index = this.options.findIndex((item) => {
          return Number(item.id) == value
        });
        return index > -1 ? this.options[index] : { fill: "white" };
      }
      return this.heading_caption;
    },
  },
};
</script>
